import { logger } from '$utils'
import { defer } from 'react-router-dom'
import { isAppStateReady } from 'src/state/store'
import useStockStore from '../store'

export default async function loader() {
  logger.debug(
    '[loader] About to await AppState being ready in Invoices loader'
  )
  await isAppStateReady()
  logger.debug('[loader] AppState should now be ready in Invoices loader')

  const getInvoices = useStockStore.getState().getInvoices()
  const getUnclassifiedFiles = useStockStore.getState().getUnclassifiedFiles()

  const getBrands =
    useStockStore.getState().brands.length == 0
      ? useStockStore.getState().getBrands()
      : []

  const getSuppliers =
    useStockStore.getState().suppliers.length == 0
      ? useStockStore.getState().getSuppliers()
      : []

  return defer({
    data: Promise.all([
      getInvoices,
      getUnclassifiedFiles,
      getBrands,
      getSuppliers,
    ])
      .then(() => true)
      .catch((error) => {
        logger.error('Invoices Promise.all error', error)
        return false
      }),
  })
}
